import { createAsyncThunk } from "@reduxjs/toolkit";
import { getActivityLogs } from "../services/apiEndPoints";

export const getActivityLogsThunk = createAsyncThunk(
  "access/getActivityLogs",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await getActivityLogs(payload); 
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || error.message || "Failed data is not loaded"
      );
    }
  }
);